export const SECURITY_BATCH_SIZE = 100;
export const APPLICATION_KEY = 'application';
